import { ApolloError, gql, useMutation } from "@apollo/client";
import { ChangeServiceActiveMutation, ChangeServiceActiveMutationVariables } from "../generated/graphql";

const CHANGE_SERVICE_ACTIVE_MUTATION = gql`
  mutation changeServiceActive($input: ChangeServiceActiveInput!) {
    changeServiceActive(input: $input) {
      ok
      err
    }
  }
`;

export const useChangeServiceActive = (
  onCompleted?: (data: ChangeServiceActiveMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<ChangeServiceActiveMutation, ChangeServiceActiveMutationVariables>(
    CHANGE_SERVICE_ACTIVE_MUTATION,
    {
      onCompleted,
      onError,
      fetchPolicy: "network-only",
    }
  );
};